export const useStyles = (theme) => ({
  root: {
    color: "#ffffff",
    paddingTop: 65,
    minHeight: "100vh",
    backgroundColor: "#0a1f3a",
    overflow: "auto",
    //width
    "&::-webkit-scrollbar": {
      width: 1,
    },

    //Track
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },

    // Handle
    "&::-webkit-scrollbar-thumb": {
      background: "#fff",
    },

    // Handle on hover
    "&::-webkit-scrollbar-thumb:hover": {
      background: "grey",
    },
  },
  toolbar: {
    ...theme.mixins.toolbar,
  },
  ListItemText: {
    fontSize: 14,
    paddingLeft: 16,
    paddingRight: 26,
    color: "black",
    [theme.breakpoints.up(960)]: {
      color: "white",
    },
  },
  iconStyle: {
    width: 10,
    height: 10,
    [theme.breakpoints.up(960)]: {
      width: 13,
      height: 13,
    },
  },
  sublist: {
    textDecoration: "none",
    outline: "none",
    color: "white",
    "&:hover": {
      color: "#00acd4",
    },
    "&:active": {
      color: "#00acd4",
    },
  },
});
